<footer *ngIf="isMasterCardUser">
  <div class="container">
    <div [class.container-fluid]="(mode$ | async) === 'signOn'" [class.container]="(mode$ | async) !== 'signOn'"></div>
    <div class="row align-items-center">
      <div class="col-xs-12 col-md-8 col-lg-6">
        <div class="footer-logo-copyright">
          <a
            [class.footer-logo]="!logoUrl"
            [href]="logoAnchorUrl"
            rel="noopener noreferrer"
            target="_blank"
            id="footer-brandLogo"
            ><img *ngIf="logoUrl" [src]="logoUrl" alt="" aria-hidden="true" class="footer-logo-image"
          /></a>
          <span [innerHTML]="copyrightHolder" class="footer-copyright"> </span>
        </div>
      </div>

      <!-- standard footer links -->
      <div class="col-xs-12 col-md-4 col-lg-6 text-center text-md-right">
        <ul class="list-inline">
          <li class="list-inline-item">
            <a [href]="legalAnchorUrl" class="d-block" rel="noopener noreferrer" target="_blank">Legal</a>
          </li>
          <li *ngIf="contactSalesAnchorUrl" class="list-inline-item">
            <a [href]="contactSalesAnchorUrl" class="d-block ml-3" id="contact-mc">
              {{ contactSalesAnchorText }}
            </a>
          </li>
          <li class="list-inline-item">
            <a [href]="contactSupportAnchorUrl" class="d-block ml-3" rel="noopener noreferrer" target="_blank">{{
              contactSupportAnchorText
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>

<footer *ngIf="!isMasterCardUser">
  <div class="container" id="precisely-container">
    <div [class.container-fluid]="(mode$ | async) === 'signOn'" [class.container]="(mode$ | async) !== 'signOn'"></div>
    <div class="d-flex flex-column">
      <!-- standard footer links -->
      <div class="text-center">
        <ul class="list-inline">
          <li class="list-inline-item">
            <a
              href="https://www.precisely.com/legal/terms-of-use"
              class="d-block"
              rel="noopener noreferrer"
              target="_blank"
              >Terms of Use</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a href="https://www.precisely.com/legal" class="d-block" rel="noopener noreferrer" target="_blank"
              >Legal</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a
              href="https://www.precisely.com/legal/privacy-notices"
              class="d-block"
              rel="noopener noreferrer"
              target="_blank"
              >Privacy Notices</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a
              href="https://www.precisely.com/legal/trademarks"
              class="d-block"
              rel="noopener noreferrer"
              target="_blank"
              >Trademarks</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a href="https://www.precisely.com/sitemap" class="d-block" rel="noopener noreferrer" target="_blank"
              >Sitemap</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a rel="noopener noreferrer" target="_blank">
              <img
                class="your_privacy_choices"
                src="./../../../assets/images/privacyoptions29x14.png"
                alt="Your Privacy Choices"
                aria-hidden="true"
              />
            </a>
          </li>
          <li class="list-inline-item">
            <a
              href="https://www.precisely.com/legal/privacy-policy/your-privacy-choices"
              class="d-block"
              rel="noopener noreferrer"
              target="_blank"
              >Your Privacy Choices</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a
              href="https://www.precisely.com/legal/california-privacy-notices"
              class="d-block"
              rel="noopener noreferrer"
              target="_blank"
              >California Privacy Notices</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a
              href="https://www.precisely.com/legal/privacy-policy/cookie-settings"
              class="d-block"
              rel="noopener noreferrer"
              target="_blank"
              >Cookie Settings</a
            >
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li *ngIf="contactSalesAnchorUrl" class="list-inline-item">
            <a *ngIf="!isMasterCardUser" [routerLink]="contactSalesAnchorUrl" class="d-block ml-3" id="contact">
              {{ contactSalesAnchorText }}
            </a>
          </li>
          <li class="list-inline-item">
            <span>|</span>
          </li>
          <li class="list-inline-item">
            <a [href]="contactSupportAnchorUrl" class="d-block ml-3" rel="noopener noreferrer" target="_blank">{{
              contactSupportAnchorText
            }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-logo-copyright" id="footer-logo-copyright">
        <span [innerHTML]="copyrightHolder" class="footer-copyright-precisely"> </span>
      </div>
    </div>
  </div>
</footer>
